import { RootState } from '@reducers';

export const selectFeatureInsuranceTemplate = (state: RootState) => state.featureReducer.insuranceTemplateReducer;
